/**
 * SpinHealth — anel de completude do diagnostico SPIN (.health-ring canonico).
 *
 * Mostra X/4 estagios SPIN preenchidos. Cor do anel comunica estado (P11):
 * 4/4 = good (verde), 2-3 = warn (amarelo), 0-1 = bad (vermelho). Recebe
 * `total` (0-4); calcula o stroke-dashoffset proporcional sobre um circulo
 * de raio 18 (perimetro ~113).
 *
 * `label` opcional renderiza uma legenda ao lado (usado fora do KpiStrip).
 */
import React from "react";

import { SpinHealthWrap, SpinHealthLegend } from "./styles";

const RAIO = 18;
const PERIMETRO = 2 * Math.PI * RAIO; // ~113.1

function classeTone(total) {
  if (total >= 4) return "good";
  if (total >= 2) return "warn";
  return "bad";
}

function HealthRing({ total = 0, max = 4 }) {
  const fracao = max > 0 ? Math.min(Math.max(total / max, 0), 1) : 0;
  const offset = PERIMETRO * (1 - fracao);
  return (
    <span
      className={`health-ring ${classeTone(total)}`}
      role="img"
      aria-label={`Diagnóstico SPIN: ${total} de ${max} estágios preenchidos`}
    >
      <svg width="44" height="44" viewBox="0 0 44 44" aria-hidden="true">
        <circle className="health-ring__bg" cx="22" cy="22" r={RAIO} />
        <circle
          className="health-ring__fg"
          cx="22"
          cy="22"
          r={RAIO}
          strokeDasharray={PERIMETRO}
          strokeDashoffset={offset}
        />
      </svg>
      <span className="health-ring__num">
        {total}/{max}
      </span>
    </span>
  );
}

/**
 * Wrapper com legenda textual (usado no header do bloco Diagnostico SPIN).
 * No KpiStrip usa-se o HealthRing direto (exportado abaixo).
 */
function SpinHealth({ total = 0, max = 4, label }) {
  if (!label) return <HealthRing total={total} max={max} />;
  return (
    <SpinHealthWrap>
      <HealthRing total={total} max={max} />
      <SpinHealthLegend>{label}</SpinHealthLegend>
    </SpinHealthWrap>
  );
}

export { HealthRing };
export default SpinHealth;
